module.exports = __webpack_public_path__ + "static/tips-3-5e396a8f54a58c6b67bd543caedbedad.svg";